function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  &.logo-wrapper {\n    img {\n      height: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import LogoImg from '../../../assets/icons/logo.svg';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
var StyledLogo = styled.div(_templateObject(), function (props) {
  return props.size ? props.size : '30px';
});

var Logo = function Logo(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/React.createElement(StyledLogo, {
    className: "logo-wrapper",
    size: size
  }, /*#__PURE__*/React.createElement("img", {
    src: LogoImg,
    alt: "Wheelseye"
  }));
};

Logo.propTypes = process.env.NODE_ENV !== "production" ? {
  size: PropTypes.string
} : {};
Logo.defaultProps = {
  theme: defaultTheme
};
export default Logo; //    ${(props) => (props.size ? props.size : '0px')};